import React, { useEffect } from "react";
import { X } from "lucide-react";

/* =======================
   Styles
======================= */
import styles from "./Modal.module.scss";

const Modal = ({ title, titleClass, children, onClose, className = "" }) => {
  // Close modal on ESC key press
  useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    document.addEventListener("keydown", handleEsc);

    return () => {
      document.removeEventListener("keydown", handleEsc);
    };
  }, [onClose]);

  // Allow closing the modal by clicking the blurred backdrop
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div
      className={`${styles["admin-modal__overlay"]} ${className}`}
      onClick={handleOverlayClick}
      aria-modal="true"
      role="dialog"
    >
      <div className={styles["admin-modal__container"]}>
        {/* Modal Header */}
        <div className={styles["admin-modal__header"]}>
          <h3
            className={`${styles["admin-modal__title"]} ${
              titleClass ? titleClass : ""
            }`}
          >
            {title}
          </h3>
          <button
            className={styles["admin-modal__close-btn"]}
            onClick={onClose}
            aria-label="Close modal"
          >
            <X size={20} strokeWidth={2.5} />
          </button>
        </div>

        {/* Modal Body */}
        <div className={styles["admin-modal__body"]}>{children}</div>
      </div>
    </div>
  );
};

export default Modal;
